const Icon = () => {
    return (
        <svg
            width="110"
            height="110"
            viewBox="0 0 110 110"
            fill="none"
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M52.6386 40.4701L46.1752 0.709106C45.7989 0.775296 45.4226 0.841485 45.0557 0.907675L52.347 40.5268C52.441 40.5079 52.5445 40.489 52.6386 40.4795"
                fill="#333132"                
                className='path'
            />
            <path
                d="M50.6252 40.9619L38.4323 2.58142C38.0748 2.69489 37.7079 2.81781 37.3503 2.94074L50.3524 41.0564C50.4465 41.028 50.5405 40.9902 50.6346 40.9619"
                fill="#333132"
                className='path'
            />
            <path
                d="M48.6965 41.7372L31.0468 5.55994C30.7081 5.73014 30.3695 5.90034 30.0308 6.07054L48.4425 41.8696C48.5271 41.8223 48.6118 41.7845 48.7059 41.7372"
                fill="#333132"
                className='path'
            />
            <path
                d="M46.8997 42.7962L24.1885 9.58801C23.878 9.80549 23.5675 10.023 23.2571 10.2499L46.6551 42.9664C46.7304 42.9097 46.8151 42.8529 46.8903 42.7962"
                fill="#333132"
                className='path'
            />
            <path
                d="M45.2626 44.1105L17.9978 14.5616C17.725 14.8169 17.4428 15.0817 17.1699 15.3465L45.0368 44.3185C45.1121 44.2523 45.1779 44.1767 45.2532 44.1105"
                fill="#333132"
                className='path'
            />
            <path
                d="M43.8233 45.6613L12.5977 20.3864C12.3625 20.6795 12.1273 20.9821 11.8921 21.2846L43.6445 45.8977C43.701 45.822 43.7668 45.7369 43.8327 45.6613"
                fill="#333132"
                className='path'
            />
            <path
                d="M42.6284 47.3916L8.07229 26.9485C7.87472 27.2794 7.68657 27.6104 7.50781 27.9413L42.4872 47.6563C42.5343 47.5712 42.5813 47.4861 42.6378 47.401"
                fill="#333132"
                className='path'
            />
            <path
                d="M41.7064 49.2733L4.54432 34.1254C4.40319 34.4752 4.26208 34.8345 4.13037 35.1939L41.5936 49.557C41.6312 49.4624 41.6688 49.3679 41.7064 49.2828"
                fill="#333132"
                className='path'
            />
            <path
                d="M41.0665 51.2495L2.09802 41.7466C2.01334 42.1154 1.91926 42.4841 1.84399 42.8623L41.0006 51.5426C41.0195 51.4481 41.0477 51.3441 41.0665 51.2495Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M40.7278 53.3203L0.799653 49.6232C0.762021 50.0014 0.733791 50.3796 0.705566 50.7578L40.709 53.6134C40.709 53.5094 40.7278 53.4149 40.7372 53.3109"
                fill="#333132"
                className='path'
            />
            <path
                d="M40.6903 55.4573L0.639893 57.5659C0.658709 57.9441 0.677518 58.3223 0.705742 58.7006L40.6997 55.7599C40.6997 55.6558 40.6903 55.5613 40.6809 55.4573"
                fill="#333132"
                className='path'
            />
            <path
                d="M40.9443 57.547L1.62769 65.4803C1.70295 65.849 1.77822 66.2273 1.86289 66.596L41.0007 57.8401C40.9819 57.7456 40.9631 57.6416 40.9443 57.547Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M41.5087 59.5516L3.77271 73.1867C3.90442 73.546 4.03613 73.9053 4.16785 74.2646L41.6028 59.8353C41.5652 59.7407 41.537 59.6556 41.4993 59.5611"
                fill="#333132"
                className='path'
            />
            <path
                d="M42.346 61.4521L7.00903 80.4958C7.18779 80.8268 7.36654 81.1672 7.55471 81.4886L42.4965 61.7169C42.4495 61.6318 42.4024 61.5372 42.3554 61.4521"
                fill="#333132"
                className='path'
            />
            <path
                d="M43.4657 63.2203L11.2522 87.2187C11.478 87.5213 11.7038 87.8239 11.939 88.1265L43.6538 63.4662C43.588 63.3905 43.5315 63.3054 43.4751 63.2203"
                fill="#333132"
                className='path'
            />
            <path
                d="M44.8393 64.8278L16.4268 93.2609C16.6902 93.5257 16.963 93.7904 17.2265 94.0552L45.0463 65.0358C44.971 64.9696 44.9052 64.894 44.8299 64.8184"
                fill="#333132"
                className='path'
            />
            <path
                d="M46.4292 66.2084L22.4197 98.4805C22.7207 98.7074 23.0312 98.9343 23.3323 99.1518L46.6833 66.3975C46.5986 66.3408 46.5139 66.2746 46.4292 66.2084Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M48.198 67.3525L29.1089 102.783C29.4382 102.962 29.7863 103.142 30.1156 103.322L48.452 67.4944C48.3673 67.4471 48.2827 67.3998 48.1886 67.3525"
                fill="#333132"
                className='path'
            />
            <path
                d="M50.0795 68.2035L36.3718 106.064C36.7199 106.196 37.0868 106.319 37.4444 106.442L50.3805 68.3075C50.2865 68.2697 50.183 68.2413 50.0889 68.2035"
                fill="#333132"
                className='path'
            />
            <path
                d="M52.0929 68.7708L44.0396 108.239C44.4065 108.314 44.7922 108.39 45.1685 108.456L52.3846 68.8181C52.2905 68.7992 52.1964 68.7803 52.1023 68.7614"
                fill="#333132"
                className='path'
            />
            <path
                d="M51.9236 109.269C52.2905 109.288 52.6668 109.307 53.0432 109.326L54.4732 69.064C54.3697 69.064 54.2662 69.0545 54.1627 69.045L51.933 109.269H51.9236Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M56.2891 69.0072L59.8265 109.137C60.2029 109.109 60.5792 109.071 60.9461 109.023L56.5995 68.9694C56.496 68.9788 56.3926 68.9883 56.2891 68.9977"
                fill="#333132"
                className='path'
            />
            <path
                d="M58.3398 68.6668L67.6633 107.851C68.0302 107.766 68.3971 107.671 68.7641 107.577L58.6409 68.5912C58.5468 68.6196 58.4433 68.6385 58.3492 68.6668"
                fill="#333132"
                className='path'
            />
            <path
                d="M60.3157 68.0428L75.2558 105.43C75.6039 105.289 75.9614 105.147 76.3001 104.995L60.5885 67.9293C60.4944 67.9671 60.4098 68.005 60.3157 68.0428Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M62.1879 67.1255L82.3871 101.932C82.7164 101.743 83.0457 101.544 83.3656 101.345L62.4325 66.9742C62.3478 67.0215 62.2631 67.0783 62.1785 67.1255"
                fill="#333132"
                className='path'
            />
            <path
                d="M63.9097 65.9341L88.9353 97.4214C89.227 97.185 89.528 96.9391 89.8103 96.7027L64.1449 65.745C64.0696 65.8112 63.9943 65.8774 63.9097 65.9341Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M65.4524 64.4968L94.7587 92.0033C95.0127 91.7291 95.2668 91.4454 95.5208 91.1712L65.6688 64.2699C65.6029 64.3455 65.5277 64.4212 65.4618 64.4968"
                fill="#333132"
                className='path'
            />
            <path
                d="M66.7789 62.8421L99.7262 85.8098C99.9426 85.4978 100.159 85.1763 100.366 84.8643L66.9389 62.6057C66.8824 62.6908 66.826 62.7665 66.7695 62.8516"
                fill="#333132"
                className='path'
            />
            <path
                d="M67.842 61.0455L103.772 78.9356C103.941 78.5952 104.11 78.2453 104.27 77.9049L67.9738 60.7808C67.9361 60.8753 67.8891 60.9604 67.842 61.0455Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M68.623 59.1166L106.782 71.513C106.895 71.1536 107.008 70.7849 107.121 70.4161L68.7171 58.8235C68.6889 58.918 68.6607 59.0126 68.6325 59.1072"
                fill="#333132"
                className='path'
            />
            <path
                d="M69.1123 57.0931L108.664 63.7404C108.73 63.3622 108.786 62.984 108.843 62.6152L69.1593 56.8094C69.1499 56.904 69.1311 57.008 69.1123 57.1026"
                fill="#333132"
                className='path'
            />
            <path
                d="M109.407 54.54L69.3098 54.6535V54.6724C69.3098 54.7764 69.3098 54.8804 69.3098 54.9845L109.398 55.8165C109.398 55.4383 109.407 55.0601 109.407 54.6819V54.5495V54.54Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M69.1968 52.8192L108.984 47.7604C108.937 47.3822 108.88 47.004 108.824 46.6257L69.1592 52.526C69.178 52.6206 69.1874 52.7246 69.1968 52.8192Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M68.7829 50.7768L107.403 39.9217C107.3 39.5529 107.196 39.1841 107.083 38.8248L68.6982 50.4931C68.7265 50.5876 68.7547 50.6822 68.7829 50.7768Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M68.0867 48.8289L104.703 32.395C104.553 32.0546 104.393 31.7048 104.233 31.3644L67.9644 48.5547C68.002 48.6493 68.049 48.7344 68.0867 48.8289Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M67.0989 46.9756L100.94 25.36C100.733 25.0386 100.526 24.7171 100.319 24.405L66.939 46.7298C66.9954 46.8149 67.0425 46.9 67.0989 46.9756Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M65.8382 45.283L96.2171 18.9774C95.9724 18.6937 95.7184 18.4006 95.455 18.1169L65.6406 45.0655C65.7065 45.1412 65.7723 45.2073 65.8288 45.283"
                fill="#333132"
                className='path'
            />
            <path
                d="M64.361 43.789L90.6097 13.3324C90.3275 13.0865 90.0358 12.8407 89.7536 12.5948L64.1353 43.5904C64.2105 43.6566 64.2952 43.7228 64.3705 43.789"
                fill="#333132"
                className='path'
            />
            <path
                d="M62.6676 42.522L84.2498 8.56683C83.9394 8.36826 83.6101 8.16024 83.2902 7.96167L62.4136 42.3613C62.4982 42.418 62.5829 42.4653 62.6676 42.522Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M60.8425 41.5292L77.2409 4.76564C76.8928 4.61435 76.5447 4.46306 76.206 4.31177L60.5603 41.4062C60.6544 41.4441 60.7485 41.4913 60.8425 41.5292Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M58.8855 40.82L69.7613 2.04245C69.3944 1.93844 69.0275 1.83442 68.6512 1.73987L58.6033 40.7444C58.6974 40.7727 58.7914 40.7917 58.8855 40.82Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M61.962 0.434991C61.5857 0.387713 61.2094 0.340435 60.8331 0.302612L56.5618 40.3661C56.6558 40.3756 56.7593 40.3851 56.8534 40.404L61.962 0.434991Z"
                fill="#333132"
                className='path'
            />
            <path
                d="M52.9397 0.0283107L54.4356 40.2904C54.5391 40.2904 54.6426 40.2904 54.7461 40.2904L54.0687 0.00939941C53.6923 0.00939941 53.316 0.0283107 52.9491 0.0377663"
                fill="#333132"
                className='path'
            />
        </svg>
    );
};

export default Icon;
